import moment from 'moment'
import React from 'react'
import { useState } from 'react'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import CustomPrimeTable from '../../../../../common/PrimeTable/CustomPrimeTable'
import useTablePaginationConfig from '../../../../../hooks/useTablePaginationConfig'
import { getOpportunities } from '../redux/dashboardOpportunityChartActions'
import Loader from '../../../../../modules/Loader/BasicLoader'

export default function OpportunitiesTable({ filters, stage }) {
  const { opportunities, isLoading } = useSelector((state) => ({
    opportunities: state.dashboardOpportunityChart.opportunities,
    isLoading: state.dashboardOpportunityChart.isLoading,
  }))

  const { options, onFilterChange, onPageChange, onSortChange, setOptions, sortMeta } = useTablePaginationConfig({
    creationDate: 1,
  })

  const [isReady, setIsReady] = useState(false)

  const dispatch = useDispatch()

  useEffect(() => {
    setOptions((p) => ({ ...p, filter: filters }))
    setIsReady(true)
  }, [filters])

  useEffect(() => {
    if (isReady) {
      dispatch(getOpportunities(stage, options))
    }
  }, [options, stage, isReady])

  const stageBody = (rowData) => {
    return `${rowData.stageData.name}`
  }

  const contactNameBody = (rowData) => {
    return (
      <span className='btn-link' onClick={() => window.open(`/contacts/${rowData.contactData.id}`, '_blank')}>
        {rowData.contactData.name}
      </span>
    )
  }

  const opportunityTypeBody = (rowData) => {
    return `${rowData.opportunityTypeData.name}`
  }

  const probabilityBody = (rowData) => {
    return `${rowData.probability} %`
  }

  const amountBody = (rowData) => {
    return `$ ${rowData.amount}`
  }

  const expectedCloseDateBody = (rowData) => {
    return moment(rowData.expectedCloseDate).utc().local().format('MM-DD-YYYY')
  }

  const createdByBody = (rowData) => {
    return `${rowData.userData.name}`
  }

  const creationDateBody = (rowData) => {
    return moment(rowData.creationDate).utc().local().format('MM-DD-YYYY hh:mm A')
  }

  const columns = [
    { field: `stageName`, header: 'Stage', style: { textAlign: 'center', width: '20%' }, body: stageBody },
    { field: `contactName`, header: 'Contact', style: { textAlign: 'center' }, body: contactNameBody },
    { field: `name`, header: 'Opportunity Name', style: { textAlign: 'center' } },
    {
      field: 'typeName',
      header: 'Opt. Type',
      style: { textAlign: 'center' },
      body: opportunityTypeBody,
    },
    { field: `probability`, header: 'Probability %', style: { textAlign: 'center' }, body: probabilityBody },
    { field: `amount`, header: 'Amount', style: { textAlign: 'center' }, body: amountBody },
    {
      field: 'expectedCloseDate',
      header: 'Exp Close Date',
      style: { textAlign: 'center' },
      body: expectedCloseDateBody,
    },
    { field: `userName`, header: 'Created By', style: { textAlign: 'center' }, body: createdByBody },
    { field: 'creationDate', header: 'Creation Date', style: { textAlign: 'center' }, body: creationDateBody },
  ]

  return (
    <>
      {isLoading && <Loader />}
      <CustomPrimeTable
        data={opportunities.data}
        columns={columns}
        defaultSortMeta={sortMeta()}
        onPage={onPageChange}
        onSort={onSortChange}
        onFilter={onFilterChange}
        query={opportunities.query}
        findHidden
        addHidden
        showActions={false}
      />
    </>
  )
}
